/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { ClosedEnum } from "../types/enums.js";

/**
 * 你想要查询的DNS记录类型。
 */
export const GetNetworkDnsType = {
  A: "A",
  Aaaa: "AAAA",
  Cname: "CNAME",
  Mx: "MX",
  Ns: "NS",
  Txt: "TXT",
} as const;
/**
 * 你想要查询的DNS记录类型。
 */
export type GetNetworkDnsType = ClosedEnum<typeof GetNetworkDnsType>;

export const GetNetworkDnsType$zodSchema = z.enum([
  "A",
  "AAAA",
  "CNAME",
  "MX",
  "NS",
  "TXT",
]).describe("你想要查询的DNS记录类型。");

export type GetNetworkDnsRequest = {
  domain: string;
  type?: GetNetworkDnsType | undefined;
};

export const GetNetworkDnsRequest$zodSchema: z.ZodType<GetNetworkDnsRequest> = z
  .object({
    domain: z.string().describe("你需要查询的域名，例如 'cn.bing.com'。"),
    type: GetNetworkDnsType$zodSchema.default("A"),
  });

export type GetNetworkDnsNotFoundDetails = {};

export const GetNetworkDnsNotFoundDetails$zodSchema: z.ZodType<
  GetNetworkDnsNotFoundDetails
> = z.object({});

/**
 * 未找到DNS记录。该域名可能不存在，或者不存在你所查询类型的记录（例如，一个没有配置MX记录的域名）。
 */
export type GetNetworkDnsNotFoundResponseBody = {
  code?: string | undefined;
  details?: GetNetworkDnsNotFoundDetails | undefined;
  message?: string | undefined;
};

export const GetNetworkDnsNotFoundResponseBody$zodSchema: z.ZodType<
  GetNetworkDnsNotFoundResponseBody
> = z.object({
  code: z.string().optional(),
  details: z.lazy(() => GetNetworkDnsNotFoundDetails$zodSchema).optional(),
  message: z.string().optional(),
}).describe(
  "未找到DNS记录。该域名可能不存在，或者不存在你所查询类型的记录（例如，一个没有配置MX记录的域名）。",
);

export type GetNetworkDnsBadRequestDetails = {};

export const GetNetworkDnsBadRequestDetails$zodSchema: z.ZodType<
  GetNetworkDnsBadRequestDetails
> = z.object({});

/**
 * 请求参数无效。请检查 `domain` 参数是否提供且格式正确。
 */
export type GetNetworkDnsBadRequestResponseBody = {
  code?: string | undefined;
  details?: GetNetworkDnsBadRequestDetails | undefined;
  message?: string | undefined;
};

export const GetNetworkDnsBadRequestResponseBody$zodSchema: z.ZodType<
  GetNetworkDnsBadRequestResponseBody
> = z.object({
  code: z.string().optional(),
  details: z.lazy(() => GetNetworkDnsBadRequestDetails$zodSchema).optional(),
  message: z.string().optional(),
}).describe("请求参数无效。请检查 `domain` 参数是否提供且格式正确。");

export type RecordT = {
  content?: string | undefined;
  flag?: number | undefined;
  port?: number | undefined;
  pri?: number | undefined;
  tag?: string | undefined;
  target?: string | undefined;
  weight?: number | undefined;
};

export const RecordT$zodSchema: z.ZodType<RecordT> = z.object({
  content: z.string().optional(),
  flag: z.int().optional(),
  port: z.int().optional(),
  pri: z.int().optional(),
  tag: z.string().optional(),
  target: z.string().optional(),
  weight: z.int().optional(),
});

/**
 * 查询成功！返回解析到的DNS记录列表。
 */
export type GetNetworkDnsResponseBody = {
  domain?: string | undefined;
  error?: string | undefined;
  records?: Array<RecordT> | undefined;
  type?: string | undefined;
};

export const GetNetworkDnsResponseBody$zodSchema: z.ZodType<
  GetNetworkDnsResponseBody
> = z.object({
  domain: z.string().optional(),
  error: z.string().optional(),
  records: z.array(z.lazy(() => RecordT$zodSchema)).optional(),
  type: z.string().optional(),
}).describe("查询成功！返回解析到的DNS记录列表。");

export type GetNetworkDnsResponse =
  | GetNetworkDnsResponseBody
  | GetNetworkDnsBadRequestResponseBody
  | GetNetworkDnsNotFoundResponseBody;

export const GetNetworkDnsResponse$zodSchema: z.ZodType<GetNetworkDnsResponse> =
  z.union([
    z.lazy(() => GetNetworkDnsResponseBody$zodSchema),
    z.lazy(() => GetNetworkDnsBadRequestResponseBody$zodSchema),
    z.lazy(() => GetNetworkDnsNotFoundResponseBody$zodSchema),
  ]);
